var map = {
	"./am.json": 3947,
	"./ar.json": 8600,
	"./bn.json": 7024,
	"./cht.json": 7688,
	"./de.json": 4173,
	"./en.json": 8380,
	"./es.json": 945,
	"./fa.json": 6346,
	"./fil.json": 9960,
	"./fr.json": 7555,
	"./hi.json": 7328,
	"./id.json": 7618,
	"./my.json": 7567,
	"./nl.json": 8863,
	"./pl.json": 4412,
	"./pt.json": 2074,
	"./ru.json": 1287,
	"./tr.json": 2996,
	"./uk.json": 5368,
	"./ur.json": 3832,
	"./vn.json": 6909
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2007;